import { useCallback } from "react";
import { RemoteParticipantData } from "store/remote-participants/types";
import { twilioSyncEnabled } from "utils";

export function useParticipantsInAreaFilter(participantsInArea: string[]) {
  const participantsInAreaFilter = useCallback(
    (p: RemoteParticipantData) => {
      return twilioSyncEnabled
        ? participantsInArea.includes(p.identity)
        : p;
    },
    [participantsInArea]
  );

  return { participantsInAreaFilter };
}
